import React, { useEffect } from "react";
import { Flex, Center, Text, Image } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import qs from "qs";
import iconSuccess from "assets/images/success-circle.svg";
import iconError from "assets/images/error-triangle.svg";
import LoadingOverlay from "components/LoadingOverlay";
import { useRegiserAccountWithInviteMutation } from "redux/services/identity";

const ConfirmAccount: React.FC<{ isForceSuccess?: boolean }> = ({
  isForceSuccess,
}) => {
  const { search } = useLocation();

  const [regiserAccountWithInviteMutation, { isSuccess, isError, isLoading }] =
    useRegiserAccountWithInviteMutation();

  useEffect(() => {
    const { inviteCode }: any = qs.parse(search.replace("?", ""));

    regiserAccountWithInviteMutation({
      inviteCode,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <Center
      className="Register"
      w="100%"
      h="100%"
      overflow="auto"
      mt="0 !important"
      p={["24px 15px", null, 0]}
    >
      {isLoading === true ? (
        <LoadingOverlay h="100%" />
      ) : (
        <Flex
          flexDir="column"
          h="100%"
          w={["100%", "364px"]}
          justify={["flex-start", null, "center"]}
        >
          <Image
            mt="52px"
            mb="30px"
            src={isForceSuccess || isSuccess ? iconSuccess : iconError}
            alt="Success"
            loading="lazy"
          />
          {(isForceSuccess || isSuccess) && (
            <>
              <Text textAlign="center" textStyle="h2">
                Verification code is confirmed!
              </Text>
              <Text mt="5px" textAlign="center" textStyle="h5">
                You will receive another email to confirm your account.
              </Text>
            </>
          )}
          {isError && (
            <>
              <Text textAlign="center" color="red" textStyle="h2">
                Provided link is invalid or expired.
              </Text>
            </>
          )}
        </Flex>
      )}
    </Center>
  );
};

export default ConfirmAccount;
